var _path, _path2, _path3, _path4, _path5, _path6, _g, _g2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgModelReplicationAndBenchmarking(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.32353 1.80498C2.50681 2.78556 1.02344 3.64847 1.02344 3.72692C1.02344 3.90342 7.55695 7.45312 7.87363 7.45312C8.1403 7.45312 14.8405 3.88381 14.8405 3.72692C14.8405 3.57002 8.1403 0.000709534 7.85696 0.000709534C7.72362 0.000709534 6.12358 0.804786 4.32353 1.80498Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 9.00249V13.4175L3.5822 15.2991L7.1644 17.1992V12.7655V8.33185L6.39911 7.95927C5.95948 7.75436 4.34749 6.89743 2.81691 6.07775L0 4.58744V9.00249Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.2489 6.5035L8.69922 8.38222V12.7907V17.1992L11.5161 15.7111C13.0467 14.8927 14.6587 14.037 15.0983 13.8324L15.8636 13.4604V9.01467C15.8636 6.5593 15.8473 4.56897 15.8311 4.58757C15.7985 4.60617 14.1865 5.46183 12.2489 6.5035Z",
    fill: "currentColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M20.4563 16.3519C18.6396 17.3324 17.1562 18.1953 17.1562 18.2738C17.1562 18.4503 23.6898 22 24.0064 22C24.2731 22 30.9733 18.4307 30.9733 18.2738C30.9733 18.1169 24.2731 14.5476 23.9898 14.5476C23.8564 14.5476 22.2564 15.3517 20.4563 16.3519Z",
    fill: "currentColor"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M16.1348 23.5494V27.9644L19.717 29.8459L23.2992 31.7461V27.3124V22.8787L22.5339 22.5061C22.0942 22.3012 20.4823 21.4443 18.9517 20.6246L16.1348 19.1343V23.5494Z",
    fill: "currentColor"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M28.3856 21.0504L24.8359 22.9291V27.3376V31.7461L27.6528 30.258C29.1834 29.4395 30.7954 28.5839 31.235 28.3793L32.0003 28.0072V23.5615C32.0003 21.1062 31.9841 19.1158 31.9678 19.1344C31.9352 19.153 30.3232 20.0087 28.3856 21.0504Z",
    fill: "currentColor"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_8240_21487)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.7305 7.87891L26.0749 10.5052L28.4193 7.87891",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.3398 2.10156H24.2011C24.6986 2.10156 25.1756 2.32292 25.5273 2.71693C25.8791 3.11095 26.0767 3.64535 26.0767 4.20257V10.5056",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_8240_21487)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.11914 24.1211L4.77472 21.4948L2.43029 24.1211",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.5098 29.8984L6.64848 29.8984C6.15105 29.8984 5.674 29.6771 5.32227 29.2831C4.97054 28.889 4.77294 28.3546 4.77294 27.7974L4.77294 21.4944",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8240_21487"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 11.2532,
    height: 12.6061,
    fill: "currentColor",
    transform: "translate(19.043)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_8240_21487"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 11.2532,
    height: 12.6061,
    fill: "currentColor",
    transform: "translate(11.8066 32) rotate(-180)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgModelReplicationAndBenchmarking);
export default __webpack_public_path__ + "static/media/ModelReplicationAndBenchmarking.6513f14d7d3551007e22493dce093b66.svg";
export { ForwardRef as ReactComponent };